export default __webpack_public_path__ + "img/065f6cbb5a14c87fa21e874b672f8fb4.png";